const category = 'AppSpecificApprovals';

const cards = [
    {
        name: "Write Off Approval",
        id: "writeOffApproval",
        fields: [
            [
                {
                    id: "WriteOffApprovalConfig",
                    layout: [
                        [
                            {id: "UseWriteOffApprovalOption"}
                        ],
                        [
                            {
                                id: "BasicWriteOffApprovalOption",
                                layout: [
                                    [
                                        {
                                            type: "contentGroup",
                                            items: [
                                                {
                                                    type: "config",
                                                    id: "WriteOffApprovalAmountGTContent",
                                                },
                                                {
                                                    type: "config",
                                                    id: "WriteOffApprovalAmountGT",
                                                },
                                                {
                                                    type: "config",
                                                    id: "WriteOffApprovalClaimAmountGTContent",
                                                },
                                                {
                                                    type: "config",
                                                    id: "WriteOffApprovalClaimAmountGT",
                                                },
                                            ],
                                        }
                                    ]
                                ]
                            }
                        ],
                        [
                            {
                                id: "ExpertWriteOffApprovalOption",
                                layout: [
                                    [{id: "CardClaimWriteOffApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "CardClaimWriteOffApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CardClaimWriteOffApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "CardClaimWriteOffApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CardClaimWriteOffApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "ACHWriteOffApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "ACHWriteOffApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ACHWriteOffApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "ACHWriteOffApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ACHWriteOffApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "BillPayWriteOffApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "BillPayWriteOffApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "BillPayWriteOffApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "BillPayWriteOffApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "BillPayWriteOffApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "CheckWriteOffApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "CheckWriteOffApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CheckWriteOffApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "CheckWriteOffApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CheckWriteOffApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "RTPWriteOffApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "RTPWriteOffApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "RTPWriteOffApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "RTPWriteOffApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "RTPWriteOffApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "ZelleWriteOffApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "ZelleWriteOffApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ZelleWriteOffApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "ZelleWriteOffApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ZelleWriteOffApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "WireWriteOffApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "WireWriteOffApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "WireWriteOffApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "WireWriteOffApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "WireWriteOffApprovalClaimAmountGT",
                                            },
                                        ],
                                    }]
                                ]
                            }
                        ]
                    ]   
                }
            ]
        ]
    },
    {
        name: "Deny Approval",
        id: "denyApproval",
        fields: [
            [
                {
                    id: "DenyApprovalConfig",
                    layout: [
                        [
                            {id: "UseDenyApprovalOption"}
                        ],
                        [
                            {
                                id: "BasicDenyApprovalOption",
                                layout: [
                                    [
                                        {
                                            type: "contentGroup",
                                            items: [
                                                {
                                                    type: "config",
                                                    id: "DenyApprovalAmountGTContent",
                                                },
                                                {
                                                    type: "config",
                                                    id: "DenyApprovalAmountGT",
                                                },
                                                {
                                                    type: "config",
                                                    id: "DenyApprovalClaimAmountGTContent",
                                                },
                                                {
                                                    type: "config",
                                                    id: "DenyApprovalClaimAmountGT",
                                                },
                                            ],
                                        }
                                    ]
                                ]
                            }
                        ],
                        [
                            {
                                id: "ExpertDenyApprovalOption",
                                layout: [
                                    [{id: "CardClaimDenyApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "CardClaimDenyApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CardClaimDenyApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "CardClaimDenyApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CardClaimDenyApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "ACHDenyApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "ACHDenyApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ACHDenyApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "ACHDenyApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ACHDenyApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "BillPayDenyApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "BillPayDenyApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "BillPayDenyApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "BillPayDenyApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "BillPayDenyApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "CheckDenyApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "CheckDenyApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CheckDenyApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "CheckDenyApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CheckDenyApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "RTPDenyApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "RTPDenyApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "RTPDenyApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "RTPDenyApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "RTPDenyApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "ZelleDenyApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "ZelleDenyApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ZelleDenyApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "ZelleDenyApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ZelleDenyApprovalClaimAmountGT",
                                            },
                                        ],
                                    }],
                                    [{id: "WireDenyApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "WireDenyApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "WireDenyApprovalAmountGT",
                                            },
                                            {
                                                type: "config",
                                                id: "WireDenyApprovalClaimAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "WireDenyApprovalClaimAmountGT",
                                            },
                                        ],
                                    }]
                                ]
                            }
                        ]
                    ]   
                }
            ],
            [
                {
                    id: "DenyReasonsExcludedFromApprovalList",
                    listItems: ["Key"],
                },
            ],
        ],
    },
    {
        name: "Provisional Credit Approval",
        id: "provisionalCreditApproval",
        fields: [
            [
                {
                    id: "ProvisionalCreditApprovalConfig",
                    layout: [
                        [
                            {id: "UseProvisionalCreditApprovalOption"}
                        ],
                        [
                            {
                                id: "BasicProvisionalCreditApprovalOption",
                                layout: [
                                    [
                                        {
                                            type: "contentGroup",
                                            items: [
                                                {
                                                    type: "config",
                                                    id: "ProvisionalCreditApprovalAmountGTContent",
                                                },
                                                {
                                                    type: "config",
                                                    id: "ProvisionalCreditApprovalAmountGT",
                                                }
                                            ],
                                        }
                                    ]
                                ]
                            }
                        ],
                        [
                            {
                                id: "ExpertProvisionalCreditApprovalOption",
                                layout: [
                                    [{id: "CardClaimProvisionalCreditApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "CardClaimProvisionalCreditApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CardClaimProvisionalCreditApprovalAmountGT",
                                            }
                                        ],
                                    }],
                                    [{id: "ACHProvisionalCreditApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "ACHProvisionalCreditApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ACHProvisionalCreditApprovalAmountGT",
                                            }
                                        ],
                                    }],
                                    [{id: "BillPayProvisionalCreditApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "BillPayProvisionalCreditApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "BillPayProvisionalCreditApprovalAmountGT",
                                            }
                                        ],
                                    }],
                                    [{id: "CheckProvisionalCreditApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "CheckProvisionalCreditApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "CheckProvisionalCreditApprovalAmountGT",
                                            }
                                        ],
                                    }],
                                    [{id: "RTPProvisionalCreditApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "RTPProvisionalCreditApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "RTPProvisionalCreditApprovalAmountGT",
                                            }
                                        ],
                                    }],
                                    [{id: "ZelleProvisionalCreditApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "ZelleProvisionalCreditApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "ZelleProvisionalCreditApprovalAmountGT",
                                            }
                                        ],
                                    }],
                                    [{id: "WireProvisionalCreditApprovalLabel"}],
                                    [{
                                        type: "contentGroup",
                                        items: [
                                            {
                                                type: "config",
                                                id: "WireProvisionalCreditApprovalAmountGTContent",
                                            },
                                            {
                                                type: "config",
                                                id: "WireProvisionalCreditApprovalAmountGT",
                                            }
                                        ],
                                    }]
                                ]
                            }
                        ]
                    ]   
                }
            ],
        ],
    },
    {
        name: "Letter Approval",
        id: "letterApproval",
        fields: [
            [
                {
                    type: "content",
                    content: `<p>Letter approval happens at a per letter level.  Approvals are routed to a workbasket SendLetterApproval in the manager workgroup.  Users with access to this workgroup can approve or reject the tasks.</p>`,
                },
            ],
            [
                {
                    id: "LetterApprovalList",
                    listItems: ["Key"],
                },
            ],
        ],
    }
];

export { cards, category };